import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import img1 from '../../assets/images/ubi/01.jpeg';
import img2 from '../../assets/images/ubi/02.jpeg';
import img3 from '../../assets/images/ubi/03.jpeg';
import img4 from '../../assets/images/ubi/04.jpeg'; // Fallback just in case
import img5 from '../../assets/images/ubi/05.jpeg';

const LocationSection = () => {

    const [data] = useState([
        { img: img1 },
        { img: img2 },
        { img: img3 },
        { img: img4 },
        { img: img5 }
    ]);

    return (
        <section className="tf-section section-location" style={{ marginBottom: '80px' }}>
            <div className="container">
                <div className="row" style={{ alignItems: 'flex-start' }}>
                    <div className="col-xl-6 col-md-12">
                        <div className="block-text pt-0 text-black" style={{ marginTop: '-60px', paddingTop: 0 }}>
                            <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000" style={{ marginTop: 0, paddingTop: 0 }}>Ubicación</h5>
                            <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">El mejor lugar en el <br />centro de la ciudad</h3>
                            <p className="fs-21 mb-33" data-aos="fade-up" data-aos-duration="1000">
                                Estamos ubicados estratégicamente en el corazón de San Miguel de Tucumán, a pocos metros de la Casa Histórica y cerca de los principales puntos de interés. Desde aquí podrás recorrer la ciudad fácilmente, disfrutar de la cultura local y descansar en un ambiente pensado para viajeros.
                            </p>
                        </div>
                    </div>
                    <div className="col-xl-6 col-md-12">
                        <div className="group-image" data-aos="fade-left" data-aos-duration="1000" style={{ position: 'relative' }}>
                            <Swiper
                                style={{
                                    "--swiper-navigation-color": "#fff",
                                    "--swiper-pagination-color": "#fff",
                                    borderRadius: '30px',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}
                                spaceBetween={0}
                                slidesPerView={1}
                                navigation={true}
                                autoplay={{ delay: 4000, disableOnInteraction: false }}
                                modules={[Navigation, Autoplay]}
                                className="location-swiper"
                            >
                                {
                                    data.map((item, index) => (
                                        <SwiperSlide key={index}>
                                            <div style={{ overflow: 'hidden' }}>
                                                <img
                                                    src={item.img}
                                                    alt={`Ubicación ${index + 1}`}
                                                    style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '30px' }}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LocationSection;
